import ICoordinates from '../types/ICoordinates';

const coordinatesEqual = (a: ICoordinates | null, b: ICoordinates | null, tolerance = 0) => {
  if (!a || !b) return false;
  return Math.abs(a.x - b.x) <= tolerance && Math.abs(a.y - b.y) <= tolerance;
};

export default coordinatesEqual;
